import { render, staticRenderFns } from "./business_detail.vue?vue&type=template&id=a9bb8530&scoped=true&"
import script from "./business_detail.vue?vue&type=script&lang=js&"
export * from "./business_detail.vue?vue&type=script&lang=js&"
import style0 from "./business_detail.vue?vue&type=style&index=0&id=a9bb8530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bb8530",
  null
  
)

export default component.exports